<div class="zone-edit-title">
  {{'Zone edit'|translate}}
</div>
  <div class="zone-edit-content">
    <div class="btns">
      <div class="btn_tabs">
        <button (click)="openTab('Main')" [class.active]="openedTabName == 'Main'">{{'Main'|translate}}</button>
        <button (click)="openTab('Style')" [class.active]="openedTabName == 'Style'"> {{'Style'|translate}}</button>
        <!-- <button (click)="openTab('Events')" [class.active]="openedTabName == 'Events'"> {{'Events'|translate}}</button> -->
      </div>
      <button class="btn_img btn_clear" (click)="redraw()" title="{{'Clear'|translate}}"></button>
    </div>
    <div class="horseparator"></div>
    <div class="zone-edit-tabs">
      <div class="zone-edit-form tabpage" id="table_edit_start" *ngIf="openedTabName == 'Main'">
        <div class="inputgroup">
          <label>{{'Name'|translate}}</label>
          <input type="text" [(ngModel)]="model.Name">
        </div>
        <div class="inputgroup">
          <label>{{'Description'|translate}}</label>
          <input type="text" [(ngModel)]="model.Comment">
        </div>
        <div class="inputgroup">
          <label>{{'Max speed'|translate}}</label>
          <div class="input-number">
            <div class="input-number-control">
              <input type="number" [(ngModel)]="model.MaxSpeed">
            </div>
            <div class="input-number-text">{{'km/h'|localizeUnits}}</div>
          </div>
        </div>
        <div class="inputgroup">
          <label>{{'Priority'|translate}}</label>
          <input type="number" [(ngModel)]="model.Priority">
        </div>
        <div class="divider"></div>
        <div class="inputgroup">
          <label>{{'Use in reports?'|translate}}</label>
          <input type="checkbox" [(ngModel)]="useInReports">
        </div>
        <app-base-group-mgmt-component [Title]="'Groups'" [Objects]="model.Groups" [groups]="groups" style="z-index: 1;">
          <ng-template let-item>
            <td>{{item.Name}}</td>
          </ng-template>
        </app-base-group-mgmt-component>
        <div class="inputgroup">
          <label>{{'Container'|translate}}</label>
          <input *ngIf="isEditMode" type="text" [value]="getSelectedContainerName()" readonly>
          <select *ngIf="!isEditMode" [(ngModel)]="model.ContainerId">
            <option *ngFor="let container of creatableContainers" [ngValue]="container.Id">{{container.Name}}</option>
          </select>
        </div>
      </div>
      <div class="zone-edit-form tabpage" id="table_edit_end" *ngIf="openedTabName == 'Style'">
        <div class="inputgroup">
          <label>{{'Zone type'|translate}}</label>
          <select title="{{'Zone type'|translate}}" [(ngModel)]="model.Style.type">
            <option value="point" [selected]="model.Style.type == 'point'" [value]="'point'">{{'Point'|translate}}</option>
            <option value="polygon" [selected]="model.Style.type == 'polygon'" [value]="'polygon'">{{'Polygon'|translate}}</option>
            <option value="polyline" [selected]="model.Style.type == 'polyline'" [value]="'polyline'">{{'Polyline'|translate}}</option>
          </select>
        </div>
        <div class="inputgroup" style="z-index: 15;" *ngIf="model.Style.type == 'point'">
          <label>{{'Icon'|translate}} </label>
          <app-icon-selector [icons]="Icons" [selectedIcon]="model.IconId" (onIconSelected)="model.IconId = $event ? $event.Id : 0;"></app-icon-selector>
        </div>
        <div class="inputgroup" *ngIf="model.Style.type == 'point' || model.Style.type == 'polyline'">
          <label>{{'Radius'|translate}}</label>
          <div class="input-number">
            <div class="input-number-control">
              <input type="number" [(ngModel)]="model.Radius">
            </div>
            <div class="input-number-text">{{'m'|localizeUnits}}</div>
          </div>
        </div>
        <div class="inputgroup" style="z-index: 14;">
          <label>
            {{'Fill color'|translate}}
          </label>
          <app-color-selector (onColorSelected)="onFillChanged($event)" [color]="model.Style.fillColor"></app-color-selector>
        </div>
        <div class="inputgroup">
          <label>{{'Fill transparency'|translate}}</label>

          <div class="input-range" style="margin-top: 10px;">
            <!-- <ngx-slider [(value)]="model.Style.fillOpacity" [options]="{floor:0, ceil:1,step:0.1}"></ngx-slider> -->
             <p-slider [(ngModel)]="model.Style.fillOpacity" [ngModelOptions]="{ standalone: true }" [min]="0" [max]="1" [step]="0.1" class="w-56" />
            <!--<input type="range" min="0" max="1" step="0.1" [(ngModel)]="model.Style.fillOpacity">-->
          </div>
        </div>
        <div class="inputgroup" style="z-index: 13;">
          <label>
            {{'Border color'|translate}}
          </label>
          <app-color-selector (onColorSelected)="onStrokeChanged($event)" [color]="model.Style.strokeColor"></app-color-selector>
        </div>
        <div class="inputgroup">
          <label>{{'Border width'|translate}}</label>
          <div class="input-number">
            <div class="input-number-control">
              <input type="number" [(ngModel)]="model.Style.strokeWidth">
            </div>
            <div class="input-number-text">px</div>
          </div>
        </div>
        <div class="inputgroup">
          <label>{{'Border transparency'|translate}}</label>
          <div class="input-range" style="margin-top: 10px;">
            <!-- <ngx-slider [(value)]="model.Style.strokeOpacity" [options]="{floor:0, ceil:1,step:0.1}"></ngx-slider> -->
            <p-slider [(ngModel)]="model.Style.strokeOpacity" [ngModelOptions]="{ standalone: true }" [step]="0.1" [min]="0" [max]="1" class="w-56" />
            <!--<input type="range" min="0" max="1" step="0.1" [(ngModel)]="model.Style.strokeOpacity">-->
          </div>
        </div>
        <div class="inputgroup">
          <label>{{'Border style'|translate}}</label>
          <select title="{{'Border style'|translate}}" [(ngModel)]="model.Style.strokeDashstyle">
            <option value="solid" [selected]="model.Style.type == 'solid'">{{'Solid'|translate}}</option>
            <option value="sash" [selected]="model.Style.type == 'dash'">{{'Dash'|translate}}</option>
            <option value="dot" [selected]="model.Style.type == 'dot'">{{'Dot'|translate}}</option>
            <option value="dashdot" [selected]="model.Style.type == 'dashdot'">{{'Dashdot'|translate}}</option>
          </select>
        </div>
      </div>
      <div class="zone-edit-form tabpage" id="table_edit_events" *ngIf="openedTabName == 'Events'">
        <div class="inputgroup">
          <label>{{'Events'|translate}}</label>
          <select title="{{'Events'|translate}}" [(ngModel)]="events">
            <option value="" [selected]="model.Flags == ''">{{'None'|translate}}</option>
            <option value="EVENTS_IN" [selected]="model.Flags == 'EVENTS_IN'">{{'Enter in geozone'|translate}}</option>
            <option value="EVENTS_OUT" [selected]="model.Flags == 'EVENTS_OUT'">{{'Leave geozone'|translate}}</option>
            <option value="EVENTS" [selected]="model.Flags == 'EVENTS'">{{'All events'|translate}}</option>
          </select>
        </div>
        <app-base-group-mgmt-component *ngIf="events.indexOf('EVENTS') >= 0" [Title]="'Objects'" [groupsUsedForObjectsSelection]="ObjectGroups"
                                       [Objects]="model.Objects" [groups]="Objects" style="z-index: 1;">
          <ng-template let-item>
            <td>{{item.Name}}</td>
          </ng-template>
        </app-base-group-mgmt-component>
      </div>
      <div class="inputgroup inputgroup_btn">
        <button class="btn_blue js-zone-edit-hide" (click)="submit()">{{'Apply'|translate}}</button>
        <button class="btn_graygray js-zone-edit-hide" (click)="close()">{{'Cancel'|translate}}</button>
      </div>
    </div>
  </div>
